export const REMOVE_ACTIVE_RESTAURANTS = 'REMOVE_ACTIVE_RESTAURANTS'

export const removeRestaurant = restaurantId => ({
	type: REMOVE_ACTIVE_RESTAURANTS,
	payload: restaurantId
})

export default function removeActiveRestaurants(restaurantId) {
	return dispatch => {
		dispatch(removeRestaurant(restaurantId))
	}
}




// WEBPACK FOOTER //
// ./src/actions/removeActiveRestaurants.js